export default "__VITE_ASSET__DzvOJ7z3__"